import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  FormFieldSet,
  PageTitle,
  useFormHandler,
  showToast,
} from "../../../../../../components";
import {
  saveRaSettingsStart,
  updateRaSettingsStart,
} from "../../../../../../redux/slices/leads/leadsSlice";

const timeZoneOptions = [
  { label: "Indian Standard Time (IST)", value: 1 },
  { label: "Eastern Standard Time (EST)", value: 2 },
  { label: "Central Standard Time (CST)", value: 3 },
  { label: "Mountain Standard Time (MST)", value: 4 },
  { label: "Pacific Standard Time (PST)", value: 5 },
];

const timeOptions = [];
for (let i = 8; i < 19; i++) {
  const ampm = i < 12 ? "AM" : "PM";
  const hour = i === 0 ? 12 : i > 12 ? i - 12 : i;
  const timeLabel = `${hour}:00 ${ampm}`;
  const timeValue = `${i.toString().padStart(2, "0")}:00`;
  timeOptions.push({ label: timeLabel, value: timeValue });
}

// const gapOptions = [
//   { label: "No gap", value: 0 },
//   { label: "1 Minute", value: 1 },
//   { label: "5 Minutes", value: 5 },
//   { label: "10 Minutes", value: 10 },
//   { label: "15 Minutes", value: 15 },
//   { label: "30 Minutes", value: 30 },
//   { label: "1 Hour", value: 60 },
// ];

const AiRecruiterCall = ({ existingUiid, fetchRaSettings }) => {
  const dispatch = useDispatch();
  const raSettings = useSelector((state) => state.leads.raSettings?.data);
  const { user } = useSelector((state) => state.auth);

  const existingData = raSettings?.find((r) => r.uiid === existingUiid) || raSettings?.[0];
  const aiCallSettings = existingData?.aiCallSettings;

  const initialFormData = {
    scheduleDays: [],
    timeZone: "",
    fromTime: "",
    toTime: "",
    // gapBetweenCalls: "",
    maxCallsPerJob: "",
    // maxCbCredits: "",
    // maxMonsterCredits: ""
  };

  const { formData, errors, handleChange, setFormData,
    validateAllFields, setErrors } = useFormHandler(initialFormData, {
      scheduleDays: { type: "checkbox", required: true },
      timeZone: { type: "select", required: true },
      fromTime: { type: "select", required: true },
      toTime: { type: "select", required: true },
      maxCallsPerJob: { type: "number", required: true },
      // maxCbCredits: { type: "number", required: true },
      // maxMonsterCredits: { type: "number", required: true },
    });

  useEffect(() => {
    if (aiCallSettings) {
      let activeDays = aiCallSettings.scheduleDays || [];
      if (activeDays.length === 5) {
        activeDays = ["all", ...activeDays];
      }
      setFormData({
        scheduleDays: activeDays,
        timeZone: aiCallSettings.timeZone || "",
        fromTime: aiCallSettings.fromTime || "",
        toTime: aiCallSettings.toTime || "",
        // gapBetweenCalls:
        //   aiCallSettings.gapBetweenCalls !== undefined
        //     ? aiCallSettings.gapBetweenCalls
        //     : "",
        maxCallsPerJob:
          aiCallSettings.maxCallsPerJob !== undefined
            ? aiCallSettings.maxCallsPerJob
            : "",
        // maxCbCredits: aiCallSettings?.maxCbCredits || "",
        // maxMonsterCredits: aiCallSettings?.maxMonsterCredits || ""
      });
    }
  }, [aiCallSettings, setFormData]);

  const handleSave = () => {
    const isValid = validateAllFields();
    if (!isValid) return;

    if (formData.fromTime && formData.toTime && formData.fromTime >= formData.toTime) {
      setErrors((prev) => ({
        ...prev,
        toTime: "To Time must be greater than From Time",
      }));
      return;
    }

    const payloadData = {
      ...formData,
      scheduleDays: formData.scheduleDays?.filter((d) => d !== "all") || [],
      maxCallsPerJob: Number(formData.maxCallsPerJob),
      // maxCbCredits: Number(formData.maxCbCredits),
      // maxMonsterCredits: Number(formData.maxMonsterCredits)
    };

    console.log("Payload::", payloadData)

    if (existingUiid) {
      dispatch(
        updateRaSettingsStart({
          uiid: existingUiid,
          payload: {
            payload: [
              {
                type: "SET",
                value: {
                  aiCallSettings: payloadData,
                  _skipFlatten: ["aiCallSettings.scheduleDays"],
                },
              },
            ],
          },
          onSuccess: () => {
            if (fetchRaSettings) fetchRaSettings();
          }
        })
      );
      showToast("AI Call Settings updated successfully!", "success");
    } else {
      dispatch(
        saveRaSettingsStart({
          coll: "Setting",
          payload: {
            aiCallSettings: payloadData,
            addedBy: user?.data?.uiid,
          },
          onSuccess: () => {
            if (fetchRaSettings) fetchRaSettings();
          }
        })
      );
      showToast("AI Call Settings saved successfully!", "success");
    }
  };

  const handleCancel = () => {
    if (aiCallSettings) {
      let activeDays = aiCallSettings.scheduleDays || [];
      if (activeDays.length === 5) {
        activeDays = ["all", ...activeDays];
      }
      setFormData({
        scheduleDays: activeDays,
        timeZone: aiCallSettings.timeZone || "",
        fromTime: aiCallSettings.fromTime || "",
        toTime: aiCallSettings.toTime || "",
        // gapBetweenCalls: aiCallSettings.gapBetweenCalls || "",
        maxCallsPerJob: aiCallSettings.maxCallsPerJob || "",
      });
    } else {
      setFormData(initialFormData);
    }
  };

  return (
    <div className="p-2">
      <PageTitle title={"AI Call Scheduling"} tag="h6" />
      <div className="my-3 mx-2 p-4 border border-gray-400 rounded bg-gray-50 ">
        <div className="grid grid-cols-5 gap-4">
          <div className="col-span-5">
            <FormFieldSet
              type="checkbox"
              title="Select days for schedule"
              multiple={true}
              options={[
                { label: "All", value: "all" },
                { label: "Monday", value: 1 },
                { label: "Tuesday", value: 2 },
                { label: "Wednesday", value: 3 },
                { label: "Thursday", value: 4 },
                { label: "Friday", value: 5 },
              ]}
              values={formData.scheduleDays}
              onChange={(value) => {
                const isAllSelected = formData.scheduleDays?.includes("all");
                const isNewAllSelected = value.includes("all");

                if (!isAllSelected && isNewAllSelected) {
                  handleChange("scheduleDays", ["all", 1, 2, 3, 4, 5]);
                } else if (isAllSelected && !isNewAllSelected) {
                  handleChange("scheduleDays", []);
                } else if (isAllSelected && isNewAllSelected && value.length < 6) {
                  handleChange("scheduleDays", value.filter((v) => v !== "all"));
                } else if (!isAllSelected && !isNewAllSelected && value.length === 5) {
                  handleChange("scheduleDays", ["all", ...value]);
                } else {
                  handleChange("scheduleDays", value);
                }
              }}
              error={errors.scheduleDays}
            />
          </div>
          <div className="col-span-4">
            <FormFieldSet
              type="select"
              title="Time Zone"
              placeholder="Select"
              options={timeZoneOptions}
              value={formData.timeZone}
              onChange={(value) => handleChange("timeZone", value)}
              error={errors.timeZone}
            />
          </div>
          <div className="col-span-2">
            <FormFieldSet
              type="select"
              title="From Time"
              placeholder="Select"
              options={timeOptions}
              value={formData.fromTime}
              onChange={(value) => handleChange("fromTime", value)}
              error={errors.fromTime}
            />
          </div>
          <div className="col-span-2">
            <FormFieldSet
              type="select"
              title="To Time"
              placeholder="Select"
              options={timeOptions}
              value={formData.toTime}
              onChange={(value) => handleChange("toTime", value)}
              error={errors.toTime}
            />
          </div>
          {/* <div className="col-span-4">
            <FormFieldSet
              type="select"
              title="Gap Between Calls"
              placeholder="Select"
              options={gapOptions}
              value={formData.gapBetweenCalls}
              onChange={(value) => handleChange("gapBetweenCalls", value)}
              error={errors.gapBetweenCalls}
            />
          </div> */}
          {/* <div className="col-span-2">
            <FormFieldSet
              type="number"
              title="Max Credits for CB"
              placeholder="Enter maximum Number of credits"
              value={formData.maxCbCredits}
              onChange={(value) => handleChange("maxCbCredits", value)}
              error={errors.maxCbCredits}
            />
          </div>
          <div className="col-span-2">
            <FormFieldSet
              type="number"
              title="Max Credits for Monster"
              placeholder="Enter maximum Number of credits"
              value={formData.maxMonsterCredits}
              onChange={(value) => handleChange("maxMonsterCredits", value)}
              error={errors.maxMonsterCredits}
            />
          </div> */}
          <div className="col-span-4">
            <FormFieldSet
              type="number"
              title="Max Calls Per Job"
              placeholder="Enter limit"
              value={formData.maxCallsPerJob}
              onChange={(value) => handleChange("maxCallsPerJob", value)}
              error={errors.maxCallsPerJob}
            />
          </div>
        </div>
        <div className="flex justify-end my-10 gap-3">
          <Button title={"Cancel"} variant="outlined" onClick={handleCancel} />
          <Button title={"Save"} onClick={handleSave} />
        </div>
      </div>
    </div>
  );
};

export default AiRecruiterCall;
